const BREAKPOINT = 3000;
export const DEFAULT_TILE_SIZE = 300;
export function getMaxSquare(width: number, height: number, N: number): number {
    const minDimension = Math.min(width, height);
    // guranteed size to fit:
    let tileSide = minDimension / Math.ceil(Math.sqrt(N || 1));
    let cols, rows;
    let steps = 0;

    // increment until it doesn't fit
    while (true) {
        steps += 1;
        cols = Math.floor(width / tileSide);
        rows = Math.ceil(N / cols);
        if (rows * tileSide < height && tileSide <= BREAKPOINT) {
            tileSide++;
        } else {
            tileSide--;
            break;
        }
    }

    if (tileSide <= 0) {
        return DEFAULT_TILE_SIZE;
    }

    return tileSide;
}
